(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-section-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var container = document.getElementById('lumo-recommendations');
    if (!container) return;
    var productId = container.dataset.productId;
    if (!productId) return;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || !data.products.length) {
          container.closest('.lumo-crosssell').style.display = 'none';
          return;
        }
        container.innerHTML = data.products.map(function(p) {
          var img = p.images && p.images[0] ? '<img class="lumo-rec-card__img" src="' + p.images[0].src + '" alt="' + p.title + '" loading="lazy">' : '<div class="lumo-rec-card__img"></div>';
          var price = (p.price / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
          return '<a class="lumo-rec-card" href="/products/' + p.handle + '">' + img + '<div class="lumo-rec-card__body"><p class="lumo-rec-card__title">' + p.title + '</p><p class="lumo-rec-card__price">' + price + '</p></div></a>';
        }).join('');
      })
      .catch(function() {
        container.closest('.lumo-crosssell').style.display = 'none';
      });
  });
  } catch(e) { console.error(e); }
})();

})();
